/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { UserRepresentation } from '../model';
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class AdminUsersApi extends BaseApi {
    bulkUpdateUsers(update) {
        throwIfNotDefined(update, 'update');
        return this.put({
            path: '/api/enterprise/admin/users',
            bodyParam: update
        });
    }
    createNewUser(userRepresentation) {
        throwIfNotDefined(userRepresentation, 'userRepresentation');
        return this.post({
            path: '/api/enterprise/admin/users',
            bodyParam: userRepresentation,
            returnType: UserRepresentation
        });
    }
    getUser(userId, opts) {
        throwIfNotDefined(userId, 'userId');
        const pathParams = {
            userId
        };
        return this.get({
            path: '/api/enterprise/admin/users/{userId}',
            pathParams,
            queryParams: opts
        });
    }
    getUsers(opts) {
        return this.get({
            path: '/api/enterprise/admin/users',
            queryParams: opts
        });
    }
    updateUserDetails(userId, userRepresentation) {
        throwIfNotDefined(userId, 'userId');
        throwIfNotDefined(userRepresentation, 'userRepresentation');
        const pathParams = {
            userId
        };
        return this.put({
            path: '/api/enterprise/admin/users/{userId}',
            pathParams,
            bodyParam: userRepresentation
        });
    }
}
